module.exports = __webpack_public_path__ + "static/media/feature.27a90bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BushfireFront/feature.jpg
// module id = 196
// module chunks = 0